/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { getListProductsETAInfoAsync } from './GetListProductsETAInfo';

export interface productETADtl {
    ProductId?: string;
    EtaDate?: string;
    EtaMessage?: string;
}
/**
 * ProductCollectionEta Input Action
 */
export class ProductCollectionEtaInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    public productIds: string[];

    public config: any;
    constructor(prodIds: string[],config: any) {
        this.productIds = prodIds;
        this.config = config;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `TODO`;
    public getCacheObjectType = () => 'TODO';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IProductCollectionEtaData {
    result: productETADtl[];
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
// const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
//     return new ProductCollectionEtaInput();
// };

/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function getProductCollectionEtaAction(input: ProductCollectionEtaInput, ctx: Msdyn365.IActionContext): Promise<IProductCollectionEtaData> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;
    const etaDtl:productETADtl[] = new Array();
    if(input.productIds !== null && input.productIds.length > 0)
    {
        const productETAinfoList = await getListProductsETAInfoAsync({callerContext: ctx, bypassCache: 'get'},ctx,input.productIds);
        for(let i=0; i < input.productIds.length; i++)
        {
            if(productETAinfoList && productETAinfoList.length > 0)
            {
                const productETA = productETAinfoList.filter(x => x.ItemId === input.productIds[`${i}`])[0].etaInfo;
                if(productETA)
                    {etaDtl.push({ProductId:input.productIds[`${i}`],EtaDate:productETA.ETADate,EtaMessage:productETA.ResultMessage});}
            }
        }
    }

    // TODO: Uncomment the below line to get the value from a service
    // const response = await Msdyn365.sendRequest<IProductCollectionEtaData[]>('/get/example/id/1', 'get');
    return { result: etaDtl };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IProductCollectionEtaData>>getProductCollectionEtaAction,
    // TODO: Give your data action a unique id
    id: 'ProductCollectionEta'
    //input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
